module.exports = __webpack_public_path__ + "img/logo-light.1fdd72c8.png";